import * as React from 'react';
import { Button, Intent } from '@blueprintjs/core';

interface Props {
    onClick: any;
    text: string;
    selected?: boolean;
};

interface State {}

export class NavigateButton extends React.Component<Props, State> {

    state: State = {

    }

    isSelected = () => {
        return this.props.selected === true;
    }

	render() {
        const {
            onClick,
            text
        } = this.props;

        const buttonIntent = this.isSelected() ? Intent.PRIMARY : Intent.NONE;

        return <Button style={{display: 'inline-block', float: 'left', marginRight: '20px', height: '60px', width: '150px', textAlign: 'center'}} onClick={onClick} intent={buttonIntent}>
            {text}
        </Button>
	}
}
